import MedicalGuideManagement from "../../modules/medical-guide/views/MedicalGuideManagement.vue"
import RouterViewRender from "../../utils/routes/router-view-render";

const MedicalGuideRoutes = {
  path: "",
  component: RouterViewRender,
  meta: {
    requiresAuth: true,
  },
  children: [
    {
      path: "gestao-guia-medico",
      component: MedicalGuideManagement,
      meta: {
        requiresAuth: true,
      },
    },
  ],
};

export default MedicalGuideRoutes;
